export default defineAppConfig({
  ui: {
    strategy: 'override',
    primary: 'green',
    gray: 'cool',
    color: {
      white: {
        solid: 'bg-cyan',
      },
    },
    notifications: {
      position: 'bottom-5 right-5',
    },
  },
});
